import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs/Rx";
import { CommunityService } from "../../shared/services/community/community.service";

@Component({
  selector: "app-community-cards",
  templateUrl: "./community-cards.component.html",
  styleUrls: ["./community-cards.component.css"]
})
export class CommunityCardsComponent implements OnInit, OnDestroy {
  activeRouteIndex: number;
  routeSubscription: Subscription;
  community$;
  communityId: any;

  constructor(private route: ActivatedRoute, private communityService: CommunityService) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.activeRouteIndex = params.index;
      this.community$ = this.communityService.getCommunityById(params.communityId);
    });
  }
  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/community-management/community-cards/community-cards.component.ts